import React, { Fragment } from 'react'
import PaginationV2 from '../../../components/pagination_v2'

const LeagueTable = ({
  leagues = [],
  activeLeagueId,
  onSelectLeague,
  pagination,
  sortOption = 'nameAsc',
  onSortChange = () => {},
  searchTerm = '',
  onSearchChange = () => {},
}) => {
  const {
    startIndex = leagues.length ? 1 : 0,
    endIndex = leagues.length,
    totalItems = leagues.length,
    currentPage = totalItems ? 1 : 0,
    totalPages = totalItems ? 1 : 0,
    onPageChange = () => {},
  } = pagination || {}

  const hasSearchQuery = Boolean(searchTerm.trim())
  const showPagination = totalItems > 0

  return (
    <section className="rounded-2xl border border-customAccent/20 bg-white shadow-xl shadow-customAccent/10 dark:border-customMuted/30 dark:bg-customSurface">
      <header className="flex flex-wrap items-center justify-between gap-1 border-b border-customAccent/20 px-4 py-2 dark:border-customSurfaceMuted">
        <div className="flex items-center gap-3">
          {/* <h2 className="text-lg font-semibold text-customInk dark:text-customHeading">League</h2>
          <span className="text-xs font-medium text-customSecondaryText dark:text-customMuted">
            {totalItems} {totalItems === 1 ? 'entry' : 'entries'}
          </span> */}
          <input 
          type="text" 
          value={searchTerm}
          onChange={(event) => onSearchChange(event.target.value)}
          className='w-full rounded-xl border border-customSurfaceMuted px-2 py-1 text-xs text-customBlack shadow-inner focus:border-customAccent focus:outline-none focus:ring-2 focus:ring-customAccent/40 dark:border-customSurface dark:bg-customSurfaceMuted dark:text-white' 
          placeholder='Search league names ... '
          aria-label='Search leagues'
          />
        </div>
        <div className="flex items-center gap-2 text-xs font-semibold text-customSecondaryText dark:text-customMuted">
          {/* <label className="hidden md:inline-block" htmlFor="league-sort-select">
            Sorting
          </label> */}
          <select
            id="league-sort-select"
            value={sortOption}
            onChange={(event) => onSortChange(event.target.value)}
            aria-label="Sort leagues"
            className="rounded-lg border border-customAccentBlue/40 bg-white px-2 py-1 text-xs font-medium text-customPrimaryText transition hover:border-customAccent focus:border-customAccent focus:outline-none focus:ring-2 focus:ring-customAccent/30 dark:border-customSurfaceMuted dark:bg-customSurface dark:text-customHeading"
          >
            <option value="nameAsc">League A-Z</option>
            <option value="nameDesc">League Z-A</option>
            <option value="idAsc">League ID Low-High</option>
            <option value="idDesc">League ID High-Low</option>
          </select>
        </div>
      </header>
      {
        leagues.length ?
          <Fragment>
            <div className="hidden md:block">
              <table className="min-w-full table-auto">
                <thead>
                  <tr className="bg-customPredawn text-left text-xs uppercase tracking-wide text-white dark:bg-customAccent/80">
                    <th className="px-4 py-3 font-semibold">No</th>
                    <th className="px-4 py-3 font-semibold">League</th>
                    <th className="px-4 py-3 font-semibold text-right">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {leagues.map((league, index) => {
                    const isActive = league.leagueId === activeLeagueId
                    const displayIndex = (startIndex || 1) + index
                    return (
                      <tr
                        key={league.leagueId}
                        className={`border-b border-customSlate/70 text-sm transition last:border-b-0 dark:border-customSurfaceMuted ${isActive
                            ? 'bg-customAccent/5 text-customAccent dark:bg-customAccent/10'
                            : 'hover:bg-customSlate/60 hover:text-customAccent dark:hover:bg-customSurfaceMuted/60'
                          }`}
                      >
                        <td className="px-4 py-3 dark:text-customMuted">{displayIndex}</td>
                        <td className="px-4 py-3">
                          <div className="flex flex-col">
                            <span className="font-medium dark:text-customMuted">{league.leagueName}</span>
                            <span className="text-xs text-customSecondaryText dark:text-customMuted">
                              {/* {league.region} - {league.eventsCount} events */}
                              {'Football'} - {league.eventsCount} events
                            </span>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-right">
                          <button
                            type="button"
                            onClick={() => onSelectLeague(league.leagueId)}
                            className={`inline-flex items-center gap-2 rounded-xl px-4 py-2 text-xs font-semibold transition focus:outline-none focus:ring-2 focus:ring-customAccent/40 ${isActive
                                ? 'bg-customAccentBlue text-white shadow-lg shadow-customAccentBlue/30'
                                : 'border border-customAccentBlue/40 text-customAccentBlue hover:bg-customAccentBlue/10 dark:border-customAccentBlue/40 dark:text-customHeading dark:hover:bg-customAccent/20'
                              }`}
                          >
                            <span className="inline-flex h-2 w-2 rounded-full bg-current" />
                            View
                          </button>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            <div className="grid gap-3 p-4 md:hidden">
              {leagues.map((league, index) => {
                const isActive = league.leagueId === activeLeagueId
                const displayIndex = (startIndex || 1) + index
                return (
                  <button
                    key={league.leagueId}
                    type="button"
                    onClick={() => onSelectLeague(league.leagueId)}
                    className={`flex flex-col gap-2 rounded-2xl border px-4 py-3 text-left transition focus:outline-none focus:ring-2 focus:ring-customAccent/30 ${isActive
                        ? 'border-transparent bg-customAccent text-white shadow-lg shadow-customAccent/30'
                        : 'border-customAccent/30 bg-white text-customPrimaryText hover:border-customAccent/40 hover:text-customAccent dark:border-customSurfaceMuted dark:bg-customSurface dark:text-customHeading dark:hover:bg-customAccent/20'
                      }`}
                  >
                    <div className="flex items-center justify-between text-xs font-semibold uppercase tracking-wide">
                      <span>No {displayIndex}</span>
                      <span>{league.eventsCount} events</span>
                    </div>
                    <div>
                      <p className="text-sm font-semibold">{league.leagueName}</p>
                      <p className="text-xs text-customSecondaryText dark:text-customMuted">{league.region}</p>
                    </div>
                  </button>
                )
              })}
            </div>
            {showPagination ? (
              <PaginationV2
                startIndex={startIndex}
                endIndex={endIndex}
                totalItems={totalItems}
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={onPageChange}
                itemLabel="leagues"
              />
            ) : null}
          </Fragment>
          :
          <div className="flex min-h-[280px] flex-col items-center justify-center gap-3 rounded-2xl border border-dashed border-customAccent/30 bg-white/80 text-center shadow-inner dark:border-customSurfaceMuted dark:bg-customSurfaceMuted/60">
            <span className="rounded-full bg-customAccent/10 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-customAccent">
              {hasSearchQuery ? 'No leagues match your search' : 'No leagues found'}
            </span>
            <p className="max-w-xs text-sm text-customSecondaryText dark:text-customMuted">
              {hasSearchQuery
                ? 'Try another keyword or clear the search box to see all leagues.'
                : 'Adjust filters or fetch a league manually to populate selectable leagues.'}
            </p>
          </div>
      }
    </section>
  )
}

export default LeagueTable
